import { createClient } from '@supabase/supabase-js'

export const supabase = createClient(
  'https://bneukabjfnjkykamzbry.supabase.co',
  'sb_publishable_t9WUB38lz2SWN7pmKUwiVg_O0cZR0nA'
)
